import React from "react";
import Header from "components/Header";
import MyCalendar from "./components/mycalendar";

function MeetingsTabs() {
  return (
    <>
      <div className='px-5 pb-9 3xl:py-6'>
        <div className='flex justify-between items-center mt-6 '>
          <p className='text-xl text-A8A8A8 3xl:text-3xl '>
            Meetings &#60;
            <span className='text-gray font-semibold'> My calender</span>
          </p>
          <Header />
        </div>
        <div>
          <MyCalendar />
        </div>
      </div>
    </>
  );
}

export default MeetingsTabs;
